require('./runtime');
"use strict";
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("./utils"));
	else if(typeof define === 'function' && define.amd)
		define(["./utils"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("./utils")) : factory(root["./utils"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(globalThis, (__WEBPACK_EXTERNAL_MODULE__78815__) => {
return (globalThis["wpBaUiCarbonToolkit"] = globalThis["wpBaUiCarbonToolkit"] || []).push([[6661],{

/***/ 25500:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {



var _interopRequireDefault = __webpack_require__(97880);
exports.__esModule = true;
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(__webpack_require__(38213));
var _defineProperty2 = _interopRequireDefault(__webpack_require__(68779));
var _react = _interopRequireWildcard(__webpack_require__(16689));
var _propTypes = _interopRequireDefault(__webpack_require__(580));
var _utils = __webpack_require__(78815);
var _baUiCarbon = __webpack_require__(6536);
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019, 2021
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */

const {
  BaPropTypes
} = _utils.propsUtils;
class TextArea extends _react.PureComponent {
  constructor() {
    super(...arguments);
    (0, _defineProperty2.default)(this, "ref", _react.default.createRef());
    (0, _defineProperty2.default)(this, "_onChange", e => {
      const {
        value
      } = e.target;
      this.props.onChange && this.props.onChange(value, e);
    });
  }
  focus() {
    const node = this.ref.current;
    node.focus();
  }
  render() {
    const {
      fireOnBlur,
      // eslint-disable-line @typescript-eslint/no-unused-vars
      disabled,
      light,
      readOnly,
      placeholder,
      value,
      rows,
      resize,
      // eslint-disable-line @typescript-eslint/no-unused-vars
      dir,
      // eslint-disable-line @typescript-eslint/no-unused-vars
      textDir,
      // eslint-disable-line @typescript-eslint/no-unused-vars
      validationErrorText,
      hasValidationError,
      className,
      style,
      // eslint-disable-line @typescript-eslint/no-unused-vars
      labelText,
      ...others
    } = this.props;
    const cProps = {
      value,
      placeholder,
      disabled,
      light,
      readOnly,
      'aria-readonly': readOnly,
      rows,
      onChange: this._onChange,
      invalid: hasValidationError,
      invalidText: validationErrorText,
      ref: this.ref,
      labelText: labelText || ''
    };
    return /*#__PURE__*/_react.default.createElement(_baUiCarbon.TextArea, (0, _extends2.default)({
      className: className
    }, others, cProps));
  }
}
exports["default"] = TextArea;
(0, _defineProperty2.default)(TextArea, "propTypes", {
  /** Specify the placeholder attribute for the <textarea> */
  placeholder: _propTypes.default.string,
  /** Specify the rows attribute for the <textarea> */
  rows: _propTypes.default.number,
  /** Provide the current value of the <textarea> */
  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  /** Specify the disabled attribute for the <textarea> */
  disabled: _propTypes.default.bool,
  /** Specify the readOnly attribute for the <textarea> */
  readOnly: _propTypes.default.bool,
  // Carbon light variant of the component
  light: _propTypes.default.bool,
  /** Deprecated - is ignored and not applicable to carbon select */
  resize: BaPropTypes.deprecated(' is ignored and not applicable to carbon select'),
  /** Deprecated - is ignored and not applicable to carbon select */
  fireOnBlur: BaPropTypes.deprecated(' is ignored and not applicable to carbon select'),
  /** Optionally provide an `onChange` handler that is called whenever <textarea>is updated */
  onChange: _propTypes.default.func,
  /** Deprecated - is ignored and not applicable to carbon select */
  dir: BaPropTypes.deprecated(' is ignored and not applicable to carbon select'),
  /** Deprecated - is ignored and not applicable to carbon select */
  textDir: BaPropTypes.deprecated(' is ignored and not applicable to carbon select'),
  /** Provide the text that is displayed when the control is in an invalid state */
  validationErrorText: _propTypes.default.string,
  /** Provide a custom className that is applied directly to the underlying <textarea> node */
  className: _propTypes.default.string,
  /** Deprecated - is ignored and not applicable to carbon select */
  style: BaPropTypes.deprecated(' is ignored and not applicable to carbon select'),
  /** Specify whether the control is currently invalid */
  hasValidationError: _propTypes.default.bool,
  /** Provide the text for a label and that will be read by a screen reader when visiting this control */
  labelText: _propTypes.default.string
});
(0, _defineProperty2.default)(TextArea, "defaultProps", {
  className: ''
});

/***/ }),

/***/ 63597:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {



var _interopRequireDefault = __webpack_require__(97880);
exports.__esModule = true;
var _TextArea = _interopRequireDefault(__webpack_require__(25500));
exports["default"] = _TextArea.default;
exports.TextArea = _TextArea.default;

/***/ }),

/***/ 6536:
/***/ ((module) => {

module.exports = require("@ba/ba-ui-carbon");

/***/ }),

/***/ 68779:
/***/ ((module) => {

module.exports = require("@babel/runtime/helpers/defineProperty");

/***/ }),

/***/ 38213:
/***/ ((module) => {

module.exports = require("@babel/runtime/helpers/extends");

/***/ }),

/***/ 97880:
/***/ ((module) => {

module.exports = require("@babel/runtime/helpers/interopRequireDefault");

/***/ }),

/***/ 580:
/***/ ((module) => {

module.exports = require("prop-types");

/***/ }),

/***/ 16689:
/***/ ((module) => {

module.exports = require("react");

/***/ }),

/***/ 78815:
/***/ ((module) => {

module.exports = __WEBPACK_EXTERNAL_MODULE__78815__;

/***/ })

},
/******/ __webpack_require__ => { // webpackRuntimeModules
/******/ var __webpack_exec__ = (moduleId) => (__webpack_require__(__webpack_require__.s = moduleId))
/******/ var __webpack_exports__ = (__webpack_exec__(63597));
/******/ return __webpack_exports__;
/******/ }
]);
});